import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function CardMembershipIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="card_membership" clipPath="url(#clip0_941_35235)">
          <path
            id="Vector"
            d="M20 2.00098H4C2.89 2.00098 2 2.89098 2 4.00098V15.001C2 16.111 2.89 17.001 4 17.001H8V22.001L12 20.001L16 22.001V17.001H20C21.11 17.001 22 16.111 22 15.001V4.00098C22 2.89098 21.11 2.00098 20 2.00098ZM20 15.001H4V13.001H20V15.001ZM20 10.001H4V5.00098C4 4.45098 4.45 4.00098 5 4.00098H19C19.55 4.00098 20 4.45098 20 5.00098V10.001Z"
            fill={white[900]}
          />
        </g>
        <defs>
          <clipPath id="clip0_941_35235">
            <rect
              width="24"
              height="24"
              fill={white[900]}
              transform="translate(0 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
